import React from "react";
import { RequestsLandingScreenContainer } from "src/containers";

export const RequestsLandingScreen = () => {
  return <RequestsLandingScreenContainer />;
};
